/**
 * @generated SignedSource<<cf37f8bf86755edf06d3ea63eb8fbc29>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type subSectionPostMagazineQuery$data = {
  readonly articles: {
    readonly " $fragmentSpreads": FragmentRefs<"subSectionPostMagazineIndexArticleList">;
  } | null | undefined;
  readonly section: {
    readonly advertZone: string | null | undefined;
    readonly entityId: string;
  };
  readonly " $fragmentSpreads": FragmentRefs<"headerPostMagazineQuery" | "subSectionPostMagazineProfileQuery">;
  readonly " $fragmentType": "subSectionPostMagazineQuery";
};
export type subSectionPostMagazineQuery$key = {
  readonly " $data"?: subSectionPostMagazineQuery$data;
  readonly " $fragmentSpreads": FragmentRefs<"subSectionPostMagazineQuery">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "entityId",
  "variableName": "entityId"
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "articlesQueueName"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "entityId"
    },
    {
      "defaultValue": 23,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "postMagazineSubSectionTopicQueueName"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "subSectionPostMagazineQuery",
  "selections": [
    {
      "alias": "articles",
      "args": [
        {
          "fields": [
            {
              "kind": "Variable",
              "name": "name",
              "variableName": "articlesQueueName"
            }
          ],
          "kind": "ObjectValue",
          "name": "filter"
        }
      ],
      "concreteType": "Queue",
      "kind": "LinkedField",
      "name": "queue",
      "plural": false,
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "after",
              "variableName": "after"
            },
            {
              "kind": "Variable",
              "name": "first",
              "variableName": "first"
            }
          ],
          "kind": "FragmentSpread",
          "name": "subSectionPostMagazineIndexArticleList"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "fields": [
            (v0/*: any*/)
          ],
          "kind": "ObjectValue",
          "name": "filter"
        }
      ],
      "concreteType": "Section",
      "kind": "LinkedField",
      "name": "section",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "entityId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "version",
              "value": 2
            }
          ],
          "kind": "ScalarField",
          "name": "advertZone",
          "storageKey": "advertZone(version:2)"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "headerPostMagazineQuery"
    },
    {
      "args": [
        (v0/*: any*/),
        {
          "kind": "Variable",
          "name": "postMagazineSubSectionTopicQueueName",
          "variableName": "postMagazineSubSectionTopicQueueName"
        }
      ],
      "kind": "FragmentSpread",
      "name": "subSectionPostMagazineProfileQuery"
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "9155b5e93aaf28942bb84025944a5c7f";

export default node;
